enum Locale {
  ARGENTINA = "es-AR",
  BRAZIL = "pt-BR",
  MEXICO = "es-MX",
}

export default Locale;
